import { Subscription } from "le-coffre-resources/dist/Admin";
import Subscriptions from "@Front/Api/LeCoffreApi/Admin/Subscriptions/Subscriptions";
import { buildStatusUiPayload } from "@Front/Components/DesignSystem/helpers/statusUi";

/**
 * Check if a stripe subscription ID represents a manual subscription
 * Manual subscriptions can have formats:
 * - manual_* (with underscore)
 * - manual-* (with dash, e.g., manual-mars-et-associes-...)
 * - manual_auto_* (with underscore for auto-created subscriptions)
 * @param stripeSubscriptionId - Stripe subscription ID to check
 * @returns true if the subscription is manual, false otherwise
 */
export function isManualSubscription(stripeSubscriptionId: string | null | undefined): boolean {
	if (!stripeSubscriptionId) {
		return false;
	}
	return stripeSubscriptionId.startsWith("manual");
}

/**
 * Get active subscription for an office.
 * Prefers subscription with status ACTIVE so Stripe banner uses the correct subscription.
 * @param officeUid - Office UID to get subscription for
 * @returns Active subscription or first one, or null if not found
 */
export async function getActiveSubscription(officeUid: string): Promise<Subscription | null> {
	// Header banner only: never tear down the notary session on 401 here; background load, no toast.
	const subscriptions = await Subscriptions.getInstance().get(
		{ q: { where: { office: { uid: officeUid } } } },
		{ skipSessionFailureOnAuthError: true, background: true },
	);
	if (!subscriptions?.length) {
		return null;
	}
	const active = subscriptions.find((s) => buildStatusUiPayload(s.status).isActive);
	return active ?? subscriptions[0] ?? null;
}
